module.exports = __webpack_public_path__ + "img/dotted-3.2b351ab6.png";